import * as angular from "angular";
import {IController} from "angular";

export class reportsSisenseViewCtrl implements IController {

  configuration: any;

  private iframeSrc: string;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.iframeSrc = `${this.configuration.url}/jwt?jwt=${this.configuration.jwt}`;
    const { SisenseFrame, enums } = window['sisense.embed'];

    const sisenseFrame = new SisenseFrame({
      url: this.configuration.url,
      dashboard: this.configuration.dashboard,
      // Which panels to show in the iFrame
      settings: {
        showToolbar: false,
        showLeftPane: true,
        showRightPane: true
      },
      id: 'sisense-iframe'
    });

    document.getElementById('sisense-jwt').onload = () => {
      sisenseFrame.render(document.getElementById('sisense-container')).then(() => {

      });
    }
  }
}

angular
  .module('bringoz.admin.reports')
  .component('reportsSisenseView', {
    bindings: {
      configuration: '<'
    },
    template: require('./reports-sisense-view.html').default,
    controller: reportsSisenseViewCtrl
  });
